import React, { Component } from 'react';
import { Descriptions, Table, Pagination, notification } from 'antd';
import { post } from '../../utils/http';
import api from '../../utils/api';
import { sessionManager } from '../../core/SessionManager';

import infoSrc from '../img/info.png';

let columns = [{
    dataIndex: 'owner',
    title: 'Area Name',
    width: 170,
    sorter: (a, b) => a.owner.length - b.owner.length,
  }, {
    dataIndex: 'customerName',
    title: 'Outlet Name',
    width: 170,
    sorter: (a, b) => a.customerName.length - b.customerName.length,
  }, {
    dataIndex: 'availableBalance',
    width: 170,
    title: <span>Outlet Balance (SGD)<a href='#' title="This displays the balance amount at each outlet."><img src={infoSrc}></img></a></span>,
    sorter: (a, b) => a.availableBalance - b.availableBalance,
    render: text => {
        return parseFloat(text).toFixed(2);
    }
  }
];
class ViewBalance extends Component {
  constructor(props) {
    super(props)
    this.state = {
      total: 0,
      data: [],
      loading: false,
      totalBalance: 0,
      columns: columns
    }
  }

  handleSearch = () => {
    this.setState({ loading: true })
    let detailId = sessionManager.getMerchantId();
    let privilege = sessionManager.getPrivilege();
    let { userPrivilege, isTaxi, isDisplayOutletTab } = privilege
    let searchData = { detailId, userPrivilege, isTaxi, isDisplayOutletTab };
    let _this = this;
    post(api.getBalanceList, searchData).then(function (response) {
      let { balanceList, totalBalance, total, isDisplayOutletTab } = response;
      if(balanceList){
        balanceList.map(item => {
          item.owner = item.account.owner;
          item.customerName = item.account.customerName;
          return item;
        })
      }
      _this.setState({
        total,
        data: balanceList,
        loading: false,
        totalBalance: totalBalance
      })
      if(isDisplayOutletTab !== null){
        privilege['isDisplayOutletTab'] = isDisplayOutletTab;
      }
      sessionManager.setPrivilege(privilege)
    }).catch(function (error) {
      notification['error']({
        message: error.errmsg,
      });
      console.log(error)
      _this.setState({
        loading: false
      })
    })
  }

  componentWillMount() {
    this.handleSearch();
  }

  render() {

    const { data, total, loading, columns, totalBalance } = this.state;

    return (

      <div style={{ width: "100%" }}>

        <Descriptions column={2}>
          <Descriptions.Item labelStyle={{ fontSize: '22px' }} contentStyle={{ fontWeight: 'bold', fontSize: '22px' }} label={<span>Total Balance<a href='#' title="This reflects the total amount of transactions since last cashout."><img src={infoSrc}/></a></span>}><span style={{color:'#03a3e4'}}>SGD {totalBalance.toFixed(2)}</span></Descriptions.Item>
          <Descriptions.Item labelStyle={{ fontSize: '22px' }} contentStyle={{ fontWeight: 'bold', fontSize: '22px' }} label="Partner Name">{sessionManager.getMerchantName()}</Descriptions.Item>
        </Descriptions>

        <div style={{ marginTop: "20px" }}>
          <Table
            scrollToFirstRowOnChange={true}
            scroll={{ x: '100%', y: 360 }}
            columns={columns}
            rowKey={record => record.accountId}
            dataSource={data}
            pagination={<Pagination style={{ marginTop: '5px' }} total={total} />}
            loading={loading} />
          

        </div>
      </div>
    )
  }
}

export default ViewBalance;